import React, { Fragment } from 'react'

import { Breadcrumb } from 'component-library/navigation/Breadcrumb/Breadcrumb'
import { BioBlock } from 'component-library/content/BioBlock/BioBlock'
import { Box } from 'component-library/compositions/Box/Box'

import { Profile as ProfileData } from 'common/client-data-types/Profile'

export interface Props {
    profile: ProfileData
    profileUrl: string
}

export const TheWestProfile: React.FC<Props> = props => {
    return (
        <Fragment>
            <Breadcrumb items={[{ text: 'Profiles' }, { text: props.profile.name }]} />
            <Box verticalSpacing="md" hasTopSpacing>
                <BioBlock
                    profile={props.profile}
                    url={props.profileUrl}
                    title={props.profile.name}
                />
            </Box>
        </Fragment>
    )
}
